import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Section, Field, Money, DurumRozeti, RozetListesi, grid } from './DetayParcalari';
import { alimTuruLabel, fmtTarih, butceTertibiText } from './detayOrtak';
import { tesisTuruText } from '../../../utils/tesisTuru';

function PdfIcon() {
  return (
    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );
}

// Bakım-Onarım Ödenek talebi bilgi kartı (İhaleler detay penceresiyle aynı düzen)
export function OdenekDetailDialog({ open, onOpenChange, record: r, displayMoney, onEdit, onExportPDF, onOpenDT, dtLinked = false, canEdit = true }) {
  if (!r) return null;
  const tertipler = butceTertibiText(r);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="odenek-detail-dialog">
        <DialogHeader>
          <DialogTitle className="text-blue-400 flex flex-wrap items-center gap-2" data-testid="odenek-detail-title">
            Ödenek Talebi Detayları{r.talep_yazi_no ? `: ${r.talep_yazi_no}` : ''}
            {dtLinked && <Badge className="bg-emerald-900/40 text-emerald-300 border-emerald-700/50 text-[11px]" data-testid="odenek-detail-dt-badge">Doğrudan Temin'e aktarıldı</Badge>}
          </DialogTitle>
          <DialogDescription className="text-gray-400" data-testid="odenek-detail-isin-adi">{r.isin_adi || '-'}</DialogDescription>
        </DialogHeader>

        <div className="space-y-5 py-2">
          <Section no="1" title="Temel Bilgiler" testId="odenek-detail-section-1">
            <div className={grid}>
              <Field label="Yıl" value={r.yil} testId="odenek-detail-yil" />
              <Field label="Tesis Türü" value={tesisTuruText(r.tesis_turu)} testId="odenek-detail-tesis-turu" />
              <Field label="Tesis Adı" value={r.tesis_adi} testId="odenek-detail-tesis-adi" />
              <Field label="İlçe" value={r.ilce} testId="odenek-detail-ilce" />
              <Field label="Alım Türü" value={alimTuruLabel(r.alim_turu)} testId="odenek-detail-alim-turu" />
              <Field label="İşin Adı" value={r.isin_adi} className="col-span-2 md:col-span-3" testId="odenek-detail-isin-adi-alan" />
            </div>
          </Section>

          <Section no="2" title="Talep ve Sorumlu" testId="odenek-detail-section-2">
            <div className={grid}>
              <Field label="Talep Yeri" value={r.talep_yeri} testId="odenek-detail-talep-yeri" />
              <Field label="İlgilenen Memur" value={r.ilgilenen_memur} testId="odenek-detail-memur" />
              <Field label="Ödenek Talep Tarihi" value={fmtTarih(r.odenek_talep_tarihi)} testId="odenek-detail-talep-tarihi" />
              <Field label="Talep Yazı No" value={r.talep_yazi_no} testId="odenek-detail-talep-yazi-no" />
              <div className="col-span-2 md:col-span-3" data-testid="odenek-detail-butce-tertibi">
                <span className="text-gray-500">Bütçe Tertibi:</span>
                <RozetListesi items={tertipler} />
              </div>
            </div>
          </Section>

          <Section no="3" title="Ödenek ve Durum" testId="odenek-detail-section-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <Money label="Ödenek Tutarı (KDV Dahil)" value={displayMoney(r.odenek_tutari)} testId="odenek-detail-tutar" tone="bg-emerald-900/20 border border-emerald-700/40" />
              <div className="flex items-center justify-between bg-gray-800/50 p-2 rounded" data-testid="odenek-detail-durum">
                <span className="text-gray-400">Ödenek Durumu:</span> <DurumRozeti value={r.odenek_durumu} testId="odenek-detail-durum-rozet" />
              </div>
              {(r.ek_taahhut_odenek_durumu || r.ek_protokol_odenek_durumu) && (
                <>
                  <Money label="Ek Taahhüt Ödenek Durumu" value={r.ek_taahhut_odenek_durumu} testId="odenek-detail-ek-taahhut" />
                  <Money label="Ek Protokol Ödenek Durumu" value={r.ek_protokol_odenek_durumu} testId="odenek-detail-ek-protokol" />
                </>
              )}
            </div>
          </Section>

          <Section no="4" title="Açıklama ve Bağlantılar" testId="odenek-detail-section-4">
            <div className="text-sm space-y-3">
              <div data-testid="odenek-detail-aciklama">
                <span className="text-gray-500">Açıklama:</span>
                <p className="text-gray-300 whitespace-pre-wrap mt-1">{r.aciklama || '-'}</p>
              </div>
              <div className={`p-3 rounded-lg border ${dtLinked ? 'bg-emerald-900/15 border-emerald-700/40' : 'bg-gray-800/40 border-gray-700/50'}`} data-testid="odenek-detail-dt-durumu">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className={dtLinked ? 'text-emerald-300' : 'text-gray-400'}>
                    {dtLinked ? 'Bu talep için Doğrudan Temin kaydı oluşturulmuş.' : (r.odenek_durumu === 'GELDİ-ÖDENDİ' ? 'Henüz Doğrudan Temin kaydı oluşturulmamış (D.T. sayfasında "Ödenekten Gelen Talepler" altında listelenir).' : 'Doğrudan Temin bağlantısı yok.')}
                  </span>
                  {dtLinked && onOpenDT && (
                    <Button size="sm" variant="outline" className="border-emerald-700/60 text-emerald-300 hover:bg-emerald-900/30 h-7 text-xs" onClick={() => onOpenDT(r)} data-testid="odenek-detail-dt-ac">
                      Doğrudan Temin'de Aç
                    </Button>
                  )}
                </div>
              </div>
              {(r.last_modified_by_name || r.last_modified_at) && (
                <p className="text-xs text-gray-500" data-testid="odenek-detail-son-duzenleyen">
                  Son düzenleyen: {r.last_modified_by_name || '-'}{r.last_modified_at ? ` · ${new Date(r.last_modified_at).toLocaleString('tr-TR')}` : ''}
                </p>
              )}
            </div>
          </Section>
        </div>

        <DialogFooter>
          {canEdit && (
            <Button onClick={() => { onOpenChange(false); onEdit(r); }} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="odenek-detail-edit-btn">Düzenle</Button>
          )}
          <Button onClick={() => onExportPDF(r)} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="odenek-detail-pdf-btn"><PdfIcon />PDF İndir</Button>
          <Button onClick={() => onOpenChange(false)} className="bg-gray-800 text-white hover:bg-gray-700" data-testid="odenek-detail-close-btn">Kapat</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
